import Relationship from 'modules/reports/orm/Relationship'

Relationship.register('groups', require('./Group').default)
Relationship.register('reports', require('./Report').default)
Relationship.register('report-folders', require('./ReportFolder').default)
Relationship.register('users', require('./User').default)
